import React, { useEffect } from 'react';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import '../../Static/Master/firmtable.css';
import DeleteIcon from '@mui/icons-material/Delete';
import { useDispatch, useSelector } from 'react-redux';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import PreviewIcon from '@mui/icons-material/Preview';
import { deleteClothIssue } from '../../Store/PHPSlice/Cutting/clothIssue';
import EditIcon from '@mui/icons-material/Edit';
import { Button } from '@mui/material';
import axios from 'axios';
import { fetchPressRegProduction } from '../../Store/PHPSlice/Press/PressingApi';


const TableBody = ({
    serialNumber,
    id,
    dt,
    prMemo,
    sono,
    orderno,
    empNm,
    itemNm,
    totqty,
    soId,
    itemId,
    sts,
    firmId,
    firmNm,
    selected,
    handleClick,
}) => {
    const dispatch = useDispatch();
    const userdata = JSON.parse(localStorage.getItem('user'));
    const baseUrl = process.env.REACT_APP_BASE_URL;
    useEffect(() => {
        const handleMessage = (event) => {
            if (event.origin !== window.location.origin) return;

            if (event.data === "REFRESH_PARENT") {
                window.location.reload();
            }
        };

        window.addEventListener("message", handleMessage);

        return () => {
            window.removeEventListener("message", handleMessage);
        };
    }, []);

    const handleDeleteClick = () => {
        // Show confirmation dialog

        const isConfirmed = window.confirm("Are you sure you want to delete this Iron Issue?");

        // If user confirms, proceed with deletion
        if (isConfirmed) {
            deleteIronIssue(id)
        }


    };

    const deleteIronIssue = async (id) => {
        try {
            const res = await axios.delete(`${baseUrl}?apicall=deleteIronIssue&prId=${id}`);
            // console.log(res);
            const msg = res?.data;
            alert(msg.msg);
            dispatch(fetchPressRegProduction());
        } catch (error) {
            console.error("Error deleting Item:", error);
        }
    };

    const handleViewClick = () => {
        window.open(`/press-info/${id}`, '_blank', 'width=1000,height=600,scrollbars=yes,resizable=yes');
    };



    const handleEditClick = () => {
        // Replace 'URL' with the actual URL you want to open

        window.open(`/ClothIssueEdit/${id}`, '_blank', 'width=1100,height=800,scrollbars=yes,resizable=yes');
    };

    const handleReturnClick = () => {
        window.open(`/press-inward/${id}`, '_blank', 'width=1200,height=700,scrollbars=yes,resizable=yes');
    };

    return (
        <>
            <TableRow hover tabIndex={-1} role="checkbox" selected={selected}>
                {/* <TableCell padding="checkbox">
                    <Checkbox disableRipple checked={selected} onChange={handleClick} />
                </TableCell> */}
                <TableCell sx={{ p: 0.4, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {serialNumber}
                </TableCell>

                <TableCell sx={{ p: 0.4, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {dt}
                </TableCell>

                <TableCell sx={{ p: 0.4, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {prMemo}
                </TableCell>


                <TableCell sx={{ p: 0.4, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {sono}
                </TableCell>

                <TableCell sx={{ p: 0.4, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {orderno}
                </TableCell>

                <TableCell sx={{ p: 0.4, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {empNm}
                </TableCell>

                <TableCell sx={{ p: 0.4, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {itemNm}
                </TableCell>

                <TableCell sx={{ p: 0.4, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {totqty}
                </TableCell>

                <TableCell sx={{ p: 0.4, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    <PreviewIcon onClick={handleViewClick} className='cursor-pointer' />
                </TableCell>

                <TableCell sx={{ p: 0.4, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    <Button className='cursor-pointer' variant="contained" color="primary" onClick={handleReturnClick} disabled={sts === '1'}>Return</Button>
                </TableCell>

                {/* <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                    <EditIcon className={`cursor-pointer ${sts === '1' ? 'disabled-icon' : ''}`} />
                </TableCell> */}

                <TableCell sx={{ p: 0.4, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    <DeleteIcon className={`cursor-pointer ${sts === '1' ? 'disabled-icon' : ''}`} onClick={handleDeleteClick}/>
                </TableCell>


            </TableRow>
        </>
    );
};

export default React.memo(TableBody);
